/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
const BaseClass = require('gemini/api/impl/Dashboard');

/**
 * This class is needed because the DashboardController that is responsible for adding the widget after the keypress (Shift + ->)
 * does not include logic that we need for replacing the placeholder widget and making a new card from starting points. We use this
 * class to override the DashboardController in BaseBoardView.
 */
class ExploreController extends BaseClass {

	/**
	 * This function determines whether to replace a placeholder widget with a live widget, create a new card, or add the columns to an existing widget
	 * @param {Array} columnInfo - contains the data for each column that was selected
	 * @returns {Promise} used by unit test
	 */
	addContentToCanvas(columnInfo) {
		const selectedWidgetId = this.view.exploreContainerLayoutModel.getSelectedWidgets()[0] ? this.view.exploreContainerLayoutModel.getSelectedWidgets()[0].id : null;
		const canvasController = this.view.boardController;
		const dashboardApi = this.view.getDashboardApi();
		const canvasAPI = dashboardApi.getCanvas();
		const widgetAPI = canvasAPI.getWidget(selectedWidgetId);
		return canvasController.getWidgetSpecFromDragObject(columnInfo).then((widgetSpec) => {
			if(widgetAPI && widgetAPI.getType() === 'placeholder') {
				const card = this.view.boardModel.layout.getSelectedChildLayouts()[0].getParent();
				card.replaceWidgetInCard(widgetSpec, selectedWidgetId);
			} else if (this.view.exploreContainerLayoutModel.exploreVM.isStartingPointsDisplayed()) {
				const cardId = this.view.exploreContainerLayoutModel.exploreVM.layoutModel.addVisCard([widgetSpec],'startingPointsCreate');
				this.view.exploreContainerLayoutModel.exploreVM.setDisplayedToCard(cardId);
			} else  {
				super.addContentToCanvas(columnInfo);
			}
		});
	}

}

export default ExploreController;



// WEBPACK FOOTER //
// ./src/js/glass/views/ExploreController.js